import * as React from 'react'
import { Button, Tooltip, OverlayTrigger, Placement} from 'react-bootstrap'

export const TooltipButton = ({ placement = 'bottom', show = 250, hide = 400, tooltipLabel, variant = 'primary', buttonClass, buttonLabel, onClick, type = '' }) => {
  return (
    <OverlayTrigger placement={placement as Placement} delay={{ show, hide }} overlay={<Tooltip>{tooltipLabel}</Tooltip>}>
      <Button type={type} variant={variant} className={buttonClass} onClick={onClick}>
        {buttonLabel}
      </Button>
    </OverlayTrigger>
  );
};